import React, { useEffect, useState } from "react";
import styled from "styled-components";
import DeeplinkMeeting from "./DeeplinkMeeting";
import { useLinksquaredService } from "../../Context/LinksquaredContext";
import { useAuthService } from "../../Context/AuthContext";
import { useTranslate } from '@tolgee/react';
import { ReactComponent as EmotiiIcon } from "../../Assets/icons/logo/logo-small.svg";
import PrimaryButton from "../GenericComponents/PrimaryButton";

const DeeplinkMeetingPickApp = ({
  meetingDataFromDeepLink,
  setMeetingDataFromDeepLink,
  isElectron,
}) => {

  const { deepLink, setIsDeepLinkAvailable } = useLinksquaredService();

  const { anonUser } = useAuthService();

  const [displayMeeting, setDisplayMeeting] = useState(!!anonUser.current);

  const handleOpenApp = () => {
    if (deepLink) {
      const userConfirmed = window.confirm(
        "Do you want to open the desktop app?"
      );
      if (userConfirmed) {
        window.location.href = deepLink; // Open the deep link if user clicks "Yes"
      }
    }
  };

  const checkDeepLinkAvailability = (link) => {
    const timeout = setTimeout(() => {
      setIsDeepLinkAvailable(false); // Assume the deep link is not available if no response
    }, 2000); // Wait 2 seconds for the deep link to respond

    const iframe = document.createElement("iframe");
    iframe.style.display = "none"; // Hide the iframe
    iframe.src = link;
    document.body.appendChild(iframe);

    iframe.onload = () => {
      clearTimeout(timeout); // Deep link was opened successfully
      setIsDeepLinkAvailable(true);
      handleOpenApp();
    };

    iframe.onerror = () => {
      clearTimeout(timeout); // Error occurred (deep link not available)
      setIsDeepLinkAvailable(false);
      window.open("https://emotii.ai", "__blank");
    };
  };

  useEffect(() => {
    if (isElectron) {
      setDisplayMeeting(true);
    }
  }, [isElectron]);
  const { t } = useTranslate();
  return (
    <Container>
      {displayMeeting ? (
        <DeeplinkMeeting
          meetingDataFromDeepLink={meetingDataFromDeepLink}
          setMeetingDataFromDeepLink={setMeetingDataFromDeepLink}
        />
      ) : (
        <ContentContainer>
          <StyledEmotiiIcon />
          <TextWrapper>
            <Title>{t('login.join_your_emotii_meeting')}</Title> 
            <Subtitle>{meetingDataFromDeepLink.title}</Subtitle>
          </TextWrapper>

          <Content>
            <PrimaryButton onClick={() => setDisplayMeeting(true)} style={{ padding: "16px", minWidth: "200px" }}>
              {t('login.continue_web')}
            </PrimaryButton>
            <PrimaryButton onClick={() => checkDeepLinkAvailability()} style={{ padding: "16px", minWidth: "200px" }}>
              {t('login.go_to_desktop')}
            </PrimaryButton>
          </Content>

          <DownloadTextWrapper>
            <DownloadText>
              {t('login.dont_have_app')}{" "}
              <DownloadLink href="https://emotii.ai" target="_blank">
                {t('login.download_it_now')}
              </DownloadLink>
            </DownloadText>
          </DownloadTextWrapper>
        </ContentContainer>
      )}
    </Container>
  );
};

export default DeeplinkMeetingPickApp;

const StyledEmotiiIcon = styled(EmotiiIcon)`
  width: 50px;
  height: 50px;
  border-radius: 4px; /* Rounded corners */
  overflow: hidden; /* Ensures the rounding is applied properly */
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 35px;
  width: 100%;
  height: 100%;
  padding: 50px 50px;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 10;
  background: ${({ theme }) => theme.menu.background};
`;

const ContentContainer = styled.div`
  background-color: ${({ theme }) => theme.menu.groupContentBackground};
  border-radius: 4px; /* Rounded corners */
  padding: 40px; /* Padding for content */
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

const Title = styled.h3`
  font-size: 20px;
  line-height: 28px;
  font-weight: 900;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  text-align: center;
`;

const Subtitle = styled.h3`
  font-size: 16px;
  line-height: 22px;
  font-weight: 400;
  color:  ${({ theme }) => theme.menu.secondaryTextColor};
  text-align: center;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column; /* Buttons stacked vertically */
  align-items: center;
  gap: 20px;
`;


const DownloadTextWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DownloadText = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  text-align: center;
`;

const DownloadLink = styled.a`
 color: ${({ theme }) => theme.menu.selectedTextColor};
  font-weight: 500;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
